import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { PageHeaderComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { ShoppingListItemModel, ShoppingListModel } from '@libs/shop/models';

@Component({
  selector: 'ui-shopping-list-header',
  templateUrl: './shopping-list-header.component.html',
  styleUrl: './shopping-list-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    PageHeaderComponent,
  ],
})
export class ShoppingListHeaderComponent {
  public shoppingList: InputSignal<ShoppingListModel> = input.required();
  public items: InputSignal<ShoppingListItemModel[]> = input.required();

  public productAmount: Signal<number> = computed(() => this.items().length);

  public editShoppingListNameClicked: OutputEmitterRef<ShoppingListModel> = output();
}
